const alertSubtle = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><circle cx="8" cy="8" r="7.25" stroke-width="1.5"/><path stroke-width="0" d="M7.25 9.99h1.5v1.5h-1.5zm0-5.48h1.5V9h-1.5z"/></svg>',
};

export { alertSubtle as default };
